import { render, staticRenderFns } from "./MarketingCenterPostCard.vue?vue&type=template&id=209edc99&scoped=true&"
import script from "./MarketingCenterPostCard.vue?vue&type=script&lang=ts&"
export * from "./MarketingCenterPostCard.vue?vue&type=script&lang=ts&"
import style0 from "./MarketingCenterPostCard.vue?vue&type=style&index=0&id=209edc99&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209edc99",
  null
  
)

export default component.exports